
import { post,get } from '../utils/http';

export function userLogin(param) {
    return post('v1/merchant/user/email/login', param);
}

export function getProfile(param) {
    return get('v1/merchant/user/profile', param);
}

export function getMerchantInfo(param) {
    return get('v1/merchant/merchant/info', param);
}